import { setData } from "rivals/shared/utils/qa";

function PodBean({ podcastId }: { podcastId: string }): JSX.Element {
  return (
    <iframe
      allowFullScreen
      allowTransparency
      data-name="pb-iframe-player"
      height="300"
      src={`https://www.podbean.com/player-v2/?i=${podcastId}&amp;square=1&amp;share=1&amp;download=1&amp;fonts=Arial&amp;skin=1&amp;font-color=auto&amp;rtl=0&amp;logo_link=episode_page&amp;btn-skin=7&amp;size=300`}
      style={{
        border: "none",
        minWidth: "min(100%, 430px)",
        overflow: "hidden"
      }}
      title={`podbean-podcast-${podcastId}`}
      width="100%"
      {...setData("podbean-podcast-embed", podcastId)}
    />
  );
}

export default PodBean;
